<mat-toolbar class="mat-elevation-z8">
  Transaction Nr: {{transaction.transactionNr}} - {{ transaction.paymentType }} <div class="spacer"></div> Created:
  {{transaction.created | date: 'yyyy-MM-dd HH:mm'}}
</mat-toolbar>

<mat-dialog-content class="mt-3">

  <div class="my-2">
    @if (transaction.paymentType === 'CreditCard' && transaction.paymentStatus === 'Reserved') {
      <button class="mr-2" mat-stroked-button color="primary" (click)="orderPaymentCapture(transaction.transactionId)"
        >
        Genomför Betalning
      </button>
    }
    @if (transaction.remainingReversalAmount > 0 && (transaction.paymentStatus === 'Paid' || transaction.paymentStatus === 'Captured' || transaction.paymentStatus === 'PartiallyReversed')) {
      <button class="mr-2" mat-stroked-button color="accent" (click)="orderPaymentModal(transaction.transactionId)"
        >
        Återbetala
      </button>
    }
    @if (transaction.paymentStatus === 'Paid' || transaction.paymentStatus === 'Captured' || transaction.paymentStatus === 'Reversed' || transaction.paymentStatus === 'PartiallyReversed' || transaction.paymentStatus === 'Checkout' || transaction.paymentStatus === 'Reserved') {
      <button class="mr-2" mat-stroked-button color="accent" (click)="getTransactionStatus(transaction.transactionId)"
        >
        Kontrollera Betalning
      </button>
    }
    @if (transaction?.paymentStatus?.toLowerCase() === 'new' || transaction?.paymentStatus?.toLowerCase() === 'checkout') {
      <button class="mr-2" mat-stroked-button color="warn"
        (click)="deleteTransaction(transaction.orderId, transaction.transactionId)"
        >
        Radera
      </button>
    }
  </div>
  <mat-divider class="my-2"></mat-divider>

  <div class="my-2">
    <div class="font-weight-bold">Paid: {{ transaction.paymentDate | date: 'yyyy-MM-dd HH:mm' }}</div>
    <div class="font-weight-bold">AmountIncVat: {{ transaction.amountIncVat }}</div>
    <div class="font-weight-bold">RemainingReversalAmount: {{ transaction.remainingReversalAmount }}</div>
    <div class="font-weight-bold">Reversed: {{ transaction.amountIncVat-transaction.remainingReversalAmount }}</div>
    <div class="font-weight-bold">Payee Reference: {{ transaction.payeeReference }}</div>
  </div>
  <mat-divider class="my-2"></mat-divider>

  <div class="my-2">
    <table>
      <tr>
        <th>Product Name</th>
        <th>Amount</th>
        <th>Vat</th>
        <th>Status</th>
        <th></th>
      </tr>
      @for (transactionRow of transaction.transactionRowVMs; track transactionRow) {
        <tr>
          <td> {{ transactionRow.productName }} </td>
          <td> {{ transactionRow.amount }} </td>
          <td> {{ transactionRow.vatAmount }} </td>
          <td> {{ transactionRow.status }} </td>
          <td>
            @if (transactionRow.status === 'New' && (transaction.paymentStatus === 'Paid' || transaction.paymentStatus === 'Captured' || transaction.paymentStatus === 'PartiallyReversed')) {
              <button class="mr-2" mat-stroked-button color="warn"
                [disabled]="transaction.remainingReversalAmount < transactionRow.amount+transactionRow.vatAmount"
                (click)="orderPaymentReversalTransactionRow(transaction.transactionId, transactionRow.transactionRowId, transactionRow.amount+transactionRow.vatAmount)">
                Återbetala
              </button>
            }
          </td>
        </tr>
      }
    </table>
  </div>

  <mat-divider class="my-2"></mat-divider>

  <div class="my-2">
    <br>
      <mat-hint>Payment URL:</mat-hint>
      @if (transaction?.paymentStatus?.toLowerCase() === 'checkout') {
        <p class="font-weight-light">
        {{baseUrl}}parkifly/flygets/checkout/payment/{{transaction.orderId}}</p>
      }
    </div>

  </mat-dialog-content>

  <mat-dialog-actions [align]="'end'">
    @if (transaction?.paymentStatus?.toLowerCase() === 'checkout') {
      <button mat-button mat-raised-button color="primary"
        (click)="copyPaymentUrl()">{{
        'FORM.COPY_PAYMENT_LINK' |
      transloco}}</button>
    }
    <button mat-button mat-dialog-close>{{ 'FORM.TERMSDIALOGCLOSE' | transloco}}</button>
    <!--<button mat-button (click)="editOrder()">
    <span *ngIf="!editMode">Ändra Order</span>
    <span *ngIf="editMode">Se Order</span>
  </button>-->
  <!-- <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Spara</button> -->
</mat-dialog-actions>